export class InvalidAnswerTypeError extends Error {
  constructor(answer: unknown, format?: string) {
    //eslint-disable-next-line
    let message = `The given answer is not an acceptable type. It likely that you have given a 'undefined',
        'empty array', 'empty string' or 'nan' where all these types should be 'null'`;

    if (format) {
      message = `The given answer is not an acceptable type, It should be 'null' or
     '${format}' and not: '${typeof answer}'`;
    }
    super(message);
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = InvalidAnswerTypeError.name; // stack traces display correctly now
  }
}
